/**
 * Cmarkdownkanban Component
 * Renders a Mermaid kanban board inside markdown
 */

"use client";

import type { CSSProperties, ReactElement } from "react";
import {
  CmarkdownvisualError,
  CmarkdownvisualErrorReason,
  CmarkdownvisualType,
} from "../Cmarkdownvisual";
import { CmarkdownkanbanView } from "./CmarkdownkanbanView";
import { useCmarkdownkanbanController } from "./useCmarkdownkanbanController";

export interface CmarkdownkanbanProps {
  content: string;
  className?: string;
  style?: CSSProperties;
}

export function Cmarkdownkanban({
  content,
  className,
  style,
}: CmarkdownkanbanProps): ReactElement {
  const controller = useCmarkdownkanbanController({ content });

  if (!controller) {
    return (
      <CmarkdownvisualError
        dataElScope="Cmarkdownkanban/Visual"
        type={CmarkdownvisualType.Kanban}
        reason={CmarkdownvisualErrorReason.Unparseable}
      />
    );
  }

  return (
    <CmarkdownkanbanView
      controller={controller}
      className={className}
      style={style}
    />
  );
}
